var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.932,24.794c0.2,0.585,0.679,1.271,1.282,1.835l-1.503,1.606c-0.879-0.823-1.54-1.792-1.861-2.73 c-1.5-4.389,0.702-7.176,2.644-9.635c1.248-1.58,2.427-3.072,2.464-4.828c0.02-0.958,0.074-3.505-4.449-6.106L4.606,3.03 c3.804,2.188,5.62,4.824,5.551,8.06c-0.053,2.494-1.519,4.351-2.937,6.146C5.396,19.545,3.82,21.54,4.932,24.794z M22.976,17.156 c-1.623,2.318-3.676,4.145-4.454,4.8c0.294,1.663-0.034,3.244-0.994,4.625c-1.975,2.843-6.077,4.167-9.266,4.22l-1.701,0.027 l0.673-1.562c0.457-1.061,0.658-2.261,0.854-3.422c0.463-2.758,0.993-5.849,5.022-7.31c0.188-0.546,1.245-3.484,3.092-6.122 c1.895-2.706,4.368-5.635,6.616-7.837c3.851-3.771,5.234-3.673,6.078-3.082C32.083,3.726,23.069,17.023,22.976,17.156z  M16.23,21.789l-1.915-1.341c-3.246,0.97-3.595,2.998-4.059,5.76c-0.125,0.742-0.252,1.499-0.444,2.257 c2.526-0.392,4.828-1.583,5.909-3.139C16.444,24.285,16.61,23.095,16.23,21.789z M27.416,3.605 c-1.73,0.968-5.993,5.184-9.413,10.068c-1.26,1.801-2.136,3.814-2.555,4.882l2.013,1.409c0.86-0.758,2.453-2.27,3.714-4.07 C24.594,11.01,27.098,5.562,27.416,3.605z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeDraw);
export default __webpack_public_path__ + "static/media/free-draw.176329e53e085226049a851c58ebca7a.svg";
export { ForwardRef as ReactComponent };